import styled from "styled-components";
import variables from "../../theme/variables";

const Container = styled.div`
  background: #0a0f16;
  padding: 16px;
  height: 100%;
  /* overflow: auto; */
  border-radius: 5px;

  > div {
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
  }

  @media (max-width: 500px) {
    padding: 8px;
  }
`;

const Trainers = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
  grid-gap: ${variables.SPACING * 2}px;
  padding: ${variables.SPACING * 2}px;

  @media (max-width: 500px) {
    grid-gap: ${variables.SPACING}px;
    grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
  }
`;

const Filters = styled.div`
  display: flex;
  overflow: visible !important;
  justify-content: center;

  @media (max-width: 1000px) {
    flex-direction: column;
  }
`;

const Filter = styled.div`
  flex: 1;
  margin: 0 8px;
`;

const FilterName = styled.div`
  font-size: 1.1.rem;
  margin-bottom: 8px;
  opacity: 0.8;
`;

const TrainerStyles = {
  Container,
  Trainers,
  Filters,
  Filter,
  FilterName,
};

export default TrainerStyles;
